<!--
* @description: 导入数据展示
-->
<template>
  <div>
    <ls-api-table
      :columns="columns"
      :data-source="dataList"
      :table-props="tableProps"
      :scroll="{fixScreen: true, extraHeight: 120, x: 2500}"
      bordered
    >
      <template #importState="{ text }">
        <a-icon class="pending-icon" v-if="text === IMPORT_STATE_MAP.PENDING" type="pause-circle" theme="filled" />
        <a-icon class="finished-icon" v-else-if="text === IMPORT_STATE_MAP.FINISHED" type="check-circle" theme="filled" />
        <a-icon class="loading-icon" v-else-if="text === IMPORT_STATE_MAP.LOADING" type="loading" />
        <a-icon class="fail-icon" v-else-if="text === IMPORT_STATE_MAP.FAIL" type="close-circle" theme="filled" />
      </template>
    </ls-api-table>
  </div>
</template>

<script>
import { fixedTable } from "lsmy-libs";
import { IMPORT_STATE_MAP, RECEIPT_PLAN_RESULT_COLUMNS } from '../enum';
export default {
  name: "ImportTable",
  mixins: [fixedTable],
  props: {
    dataList: {
      type: Array,
      default: () => ([])
    },
    tableType: {
      type: String,
      default: 'normal'
    }
  },
  data () {
    // 导入状态
    this.IMPORT_STATE_MAP = IMPORT_STATE_MAP;
    return {
      tableProps: {}
    }
  },
  computed: {
    columns () {
      let result = [];
      switch (this.tableType) {
        case 'error': // 异常数据
          result = this.stickyFixedColumns([
            {
              title: ' ',
              dataIndex: 'errorInfo',
              width: 200,
              fixed: 'left',
              customRender: (text) => <div title={text} class="inline-breakAll-ellipsis" style="color: red;">{text}</div>
            },
            ...JSON.parse(JSON.stringify(RECEIPT_PLAN_RESULT_COLUMNS)).filter(item => item.dataIndex !== 'importState')
          ])
          break;
        default:
          result = this.stickyFixedColumns(JSON.parse(JSON.stringify(RECEIPT_PLAN_RESULT_COLUMNS)));
          break;
      }
      return result;
    }
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
@iconSize: 18px;
.loading-icon {
  font-size: @iconSize;
  color: #007EF9;
}
.pending-icon {
  font-size: @iconSize;
  color: #007EF9;
}
.fail-icon {
  font-size: @iconSize;
  color: #FF382C;
}
.finished-icon {
  font-size: @iconSize;
  color: #0CBE0F;
}
</style>
